import React from 'react'
import { StaticsText } from 'src/components'
import { useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { getFormatedPrice } from 'src/core/helpers'
import styles from './CurrencyBalanceCards.module.scss'
import { selectCurrencyToken, summaryBalanceSelector } from 'src/features'
import CurrencyBalanceCardsButtons from './CurrencyBalanceCardsButtons/CurrencyBalanceCardsButtons'
import { currencyCodes } from 'src/features/currencies/constants'

const CurrencyBalanceCards: React.FC = () => {
  const { t } = useTranslation()
  const currency_code = useAppSelector(selectCurrencyToken)
  const { list } = useAppSelector(summaryBalanceSelector)

  const numberFormat = (number: number, currency: string = 'EUR') => {
    if (!currencyCodes.includes(currency)) return 0
    return getFormatedPrice(number, currency)
  }

  const currentBalance = list.find(item => item.code === currency_code)?.balance
  const currenctCurrencyBalance = numberFormat(currentBalance || 0, currency_code)

  const textsArray = list?.map(item => {
    if (item.balance !== 0) {
      const label = `${item.code} ${t(`Summary.Balance`)}`
      return { label, text: `${numberFormat(item.balance, item.code)}` }
    }
  }).filter(item => !!item)

  return <>
    <div className='card-content'>
      <p className='data-title-small'>{t(`Summary.Balance`)}</p>
      <p className='data-value-title-small'>
        {list.length > 0 && <span>{currenctCurrencyBalance}</span>}
      </p>
      <div className={`${styles['scroll-bar']}`}>
        {textsArray.map((item, idx) => <><br />
          <StaticsText label={item?.label} text={item?.text} key={idx} />
        </>)}
      </div>
    </div>
    <CurrencyBalanceCardsButtons />
  </>
}

export default CurrencyBalanceCards
